import type { NoteInfo } from './notes-list';

export type TTSearchMusicians = {
  id: number;
  title: string;
  url: string;
};

export type TTSearchPopular = {
  id: number;
  title: string;
  url: string;
  img: {
    src: string;
  };
};

export type TTSearchNotes = NoteInfo;

export type TSearchResponse = {
  data: {
    musicians: TTSearchMusicians[];
    popular: TTSearchPopular[];
    notes: TTSearchNotes[];
  };
  pager: {
    page_current: number;
    pages_all: number;
    records_all: number;
    records_per_page: number;
  };
};
